module.exports = __webpack_public_path__ + "img/drag_and_drop_icon.0cd0b687.svg";